import React from 'react'

const GettingStartedIcon = (
  <>
    <path
      d="M27.8751 0.5H5.86108C4.53549 0.501588 3.26464 1.02888 2.3273 1.96622C1.38997 2.90356 0.862672 4.17441 0.861084 5.5V41.5C0.861084 42.8261 1.38787 44.0979 2.32555 45.0355C3.26323 45.9732 4.535 46.5 5.86108 46.5H27.8751C29.2012 46.5 30.4729 45.9732 31.4106 45.0355C32.3483 44.0979 32.8751 42.8261 32.8751 41.5V5.5C32.8751 4.84339 32.7458 4.19321 32.4945 3.58658C32.2432 2.97995 31.8749 2.42876 31.4106 1.96447C30.9463 1.50017 30.3951 1.13188 29.7885 0.880602C29.1819 0.629329 28.5317 0.5 27.8751 0.5Z"
      fill="#444444"
    />
    <path
      d="M30.889 37.5C30.889 37.7652 30.7836 38.0196 30.5961 38.2071C30.4086 38.3946 30.1542 38.5 29.889 38.5H3.875C3.60978 38.5 3.35543 38.3946 3.16789 38.2071C2.98036 38.0196 2.875 37.7652 2.875 37.5L2.882 7.5C2.882 7.23478 2.98736 6.98043 3.17489 6.79289C3.36243 6.60536 3.61678 6.5 3.882 6.5H29.889C30.1542 6.5 30.4086 6.60536 30.5961 6.79289C30.7836 6.98043 30.889 7.23478 30.889 7.5V37.5Z"
      fill="#47B0EA"
    />
    <path
      d="M24.457 19.6871L17.457 14.6871C17.2874 14.566 17.0843 14.501 16.876 14.501C16.6677 14.501 16.4646 14.566 16.295 14.6871L9.295 19.6871C9.16535 19.7794 9.0596 19.9013 8.98655 20.0427C8.9135 20.1841 8.87526 20.3409 8.875 20.5001V29.5001C8.875 29.7653 8.98036 30.0196 9.16789 30.2072C9.35543 30.3947 9.60978 30.5001 9.875 30.5001H14.875V24.5251H18.875V30.5001H23.875C24.1402 30.5001 24.3946 30.3947 24.5821 30.2072C24.7696 30.0196 24.875 29.7653 24.875 29.5001V20.5001C24.875 20.3411 24.837 20.1844 24.7643 20.043C24.6916 19.9016 24.5863 19.7796 24.457 19.6871Z"
      fill="white"
    />
  </>
)

export default GettingStartedIcon
